/* eslint-disable react/jsx-curly-brace-presence */
import React from 'react'
import VeyetalsCard from './VeyetalsCard/VeyetalsCard'
import ProgressBar from '../ProgressBar/ProgressBar'
import mapStressLevel from '../../utils/mapStressLevel'
import { ReactComponent as HRIcon } from '../../assests/svg/pulse.svg'
import { ReactComponent as HRVIcon } from '../../assests/svg/pulse-line.svg'
import { ReactComponent as O2Icon } from '../../assests/svg/oxygen.svg'
import { ReactComponent as RespIcon } from '../../assests/svg/lungs.svg'
import { ReactComponent as BPIcon } from '../../assests/svg/blood-bank.svg'
import { ReactComponent as StressIcon } from '../../assests/svg/smile-face.svg'
import { ReactComponent as GlucoseIcon } from '../../assests/svg/glucose.svg'
import './VeyetalsCards.scss'

export default function VeyetalsCards({ result, progress }) {
  const { hr, hrv, o2, resp, systolic, diastolic, stress, glucose } = result

  const getProgressSymbol = () => {
    return progress === 100 ? '!' : '-'
  }

  const validateVital = (vital, lowerConstraint) => {
    return result?.isValidHeartRate
      ? vital !== undefined && vital > lowerConstraint
        ? vital
        : '-'
      : getProgressSymbol()
  }

  const validBP = (systolic, diastolic) => {
    return result?.isValidBloodPressure
      ? systolic !== undefined &&
        systolic > -1 &&
        diastolic !== undefined &&
        diastolic > -1
        ? `${systolic}/${diastolic}`
        : '-'
      : getProgressSymbol()
  }

  const validStress = (stress) => {
    return result?.isValidHeartRate
      ? mapStressLevel(stress)
      : getProgressSymbol()
  }

  return (
    <div className='veyetals-cards'>
      <div className='veyetals-cards__container'>
        <ProgressBar progress={progress} />
        <div className='veyetals-cards__card-container'>
          <div className='veyetals-cards__box'>
            <VeyetalsCard
              vital={'Heart Rate'}
              value={validateVital(hr, -1)}
              unit={'bpm'}
              icon={
                <HRIcon className='veyetals-card__icon veyetals-card__icon--hr' />
              }
              color={'#ff235b'}
            />

            <VeyetalsCard
              vital={'Heart Rate Variability'}
              value={validateVital(hrv, -1)}
              unit={'ms'}
              icon={
                <HRVIcon className='veyetals-card__icon veyetals-card__icon--hrv' />
              }
              color={'#eb3f4a'}
            />

            {/* <VeyetalsCard
              vital={'Glucose'}
              value={validateVital(glucose, -1)}
              unit={'mg/dL'}
              icon={
                <GlucoseIcon className='veyetals-card__icon veyetals-card__icon--glucose' />
              }
              color={'#AA2D32'}
            /> */}

            <VeyetalsCard
              vital={'Blood Pressure'}
              value={validBP(systolic, diastolic)}
              unit={''}
              icon={
                <BPIcon className='veyetals-card__icon veyetals-card__icon--bp' />
              }
              color={'#d64643'}
            />
          </div>
          <div className='veyetals-cards__box'>
            <VeyetalsCard
              vital={'Oxygen Saturation'}
              value={validateVital(o2, -1)}
              unit={'%'}
              icon={
                <O2Icon className='veyetals-card__icon veyetals-card__icon--o2Sat' />
              }
              color={'#10237c'}
            />

            <VeyetalsCard
              vital={'Respiration Rate'}
              value={validateVital(resp, -1)}
              unit={'BPM'}
              icon={
                <RespIcon className='veyetals-card__icon veyetals-card__icon--respRate' />
              }
              color={'#ff9c8a'}
            />

            <VeyetalsCard
              vital={'Stress'}
              value={validStress(stress)}
              unit={''}
              icon={
                <StressIcon className='veyetals-card__icon veyetals-card__icon--stress' />
              }
              color={'#40c035'}
            />
          </div>
        </div>
      </div>
    </div>
  )
}
